import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_6e56adae from 'nuxt_plugin_plugin_6e56adae' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_dayjsplugin_93bdb2ce from 'nuxt_plugin_dayjsplugin_93bdb2ce' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_intersectionobserver_38c28554 from 'nuxt_plugin_intersectionobserver_38c28554' // Source: ./nuxt-polyfill/intersection-observer.js (mode: 'all')
import nuxt_plugin_gtm_7e86d59a from 'nuxt_plugin_gtm_7e86d59a' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_templatesplugin9caf8fc8_01edc2fc from 'nuxt_plugin_templatesplugin9caf8fc8_01edc2fc' // Source: ./templates.plugin.9caf8fc8.js (mode: 'all')
import nuxt_plugin_previewclient_fe53587e from 'nuxt_plugin_previewclient_fe53587e' // Source: ../../../plugins/preview.client.js (mode: 'client')
import nuxt_plugin_storyblokNuxtHelper_4e64c830 from 'nuxt_plugin_storyblokNuxtHelper_4e64c830' // Source: ../../@soenergy/frontend-library/src/nuxt-plugins/storyblokNuxtHelper.js (mode: 'all')
import nuxt_plugin_cookieconsentclient_4a1cd458 from 'nuxt_plugin_cookieconsentclient_4a1cd458' // Source: ../../../plugins/cookie-consent.client.js (mode: 'client')
import nuxt_plugin_directives_1d3e970e from 'nuxt_plugin_directives_1d3e970e' // Source: ../../../plugins/directives.js (mode: 'all')
import nuxt_plugin_vuecookiesclient_32f3d87e from 'nuxt_plugin_vuecookiesclient_32f3d87e' // Source: ../../../plugins/vue-cookies.client.js (mode: 'client')
import nuxt_plugin_filters_57ec6061 from 'nuxt_plugin_filters_57ec6061' // Source: ../../../plugins/filters.js (mode: 'all')
import nuxt_plugin_analytics_284b3bb6 from 'nuxt_plugin_analytics_284b3bb6' // Source: ../../../plugins/analytics.js (mode: 'all')
import nuxt_plugin_store_9429320a from 'nuxt_plugin_store_9429320a' // Source: ../../../plugins/store.js (mode: 'all')
import nuxt_plugin_breakpoints_db986c4c from 'nuxt_plugin_breakpoints_db986c4c' // Source: ../../../plugins/breakpoints.js (mode: 'all')
import nuxt_plugin_datadogclient_5e1fee6a from 'nuxt_plugin_datadogclient_5e1fee6a' // Source: ../../../plugins/datadog.client.js (mode: 'client')
import nuxt_plugin_authenticationclient_231561db from 'nuxt_plugin_authenticationclient_231561db' // Source: ../../../plugins/authentication.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"So Energy - Great value green energy made easy","htmlAttrs":{"lang":"en-GB"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"http-equiv":"Cache-control","content":"no-cache"},{"hid":"description","name":"description","content":""},{"name":"apple-mobile-web-app-title","content":"So Energy"},{"name":"application-name","content":"So Energy"},{"name":"msapplication-TileColor","content":"#00d9b0"},{"name":"theme-color","content":"#ffffff"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script-so-energy":["innerHTML"],"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"script":[{"hid":"gtm-script-so-energy","innerHTML":"window.dataLayer = window.dataLayer || []\nfunction gtag() {\n  dataLayer.push(arguments)\n}\n\n\u002F\u002F set default consent\ngtag(\"consent\", \"default\", {\n  ad_storage: \"denied\",\n  analytics_storage: \"denied\",\n  functionality_storage: \"denied\",\n  personalization_storage: \"denied\",\n  security_storage: \"granted\"\n})\n\nfunction getCookie(cookieName) {\n  var name = cookieName + \"=\"\n  var decodedCookie = decodeURIComponent(document.cookie)\n  var splitCookie = decodedCookie.split(\";\")\n  for (var i = 0; i \u003C splitCookie.length; i++) {\n    var cookie = splitCookie[i]\n    while (cookie.charAt(0) == \" \") {\n      cookie = cookie.substring(1)\n    }\n    if (cookie.indexOf(name) == 0) {\n      return cookie.substring(name.length, cookie.length)\n    }\n  }\n  return \"\"\n}\n\nfunction getSavedConsent() {\n  var fetchCookie = getCookie(\"cookie-preferences\")\n  return fetchCookie ? JSON.parse(fetchCookie) : \"\"\n}\n\nfunction sendDataToGTM(data) {\n  if (typeof gtag === \"undefined\") {\n    return\n  }\n\n  var gtmVariables = {\n    security_storage: \"granted\"\n  }\n  data.forEach(function(item) {\n    if (item.id === \"functional\") {\n      gtmVariables[\"functionality_storage\"] = item.value ? \"granted\" : \"denied\"\n    }\n    if (item.id === \"advertising\") {\n      gtmVariables[\"ad_storage\"] = item.value ? \"granted\" : \"denied\"\n      gtmVariables[\"personalization_storage\"] = item.value\n        ? \"granted\"\n        : \"denied\"\n    }\n    if (item.id === \"performance\") {\n      gtmVariables[\"analytics_storage\"] = item.value ? \"granted\" : \"denied\"\n    }\n  })\n\n  gtag(\"consent\", \"update\", gtmVariables)\n}\n\n\u002F\u002F update consent\nvar savedConsent = getSavedConsent()\nif (savedConsent) {\n  sendDataToGTM(savedConsent)\n}","type":"text\u002Fjavascript","charset":"utf-8","skip":true},{"src":"https:\u002F\u002Fwww.googleoptimize.com\u002Foptimize.js?id=GTM-NBCJMQ6","skip":false,"defer":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-WPSZ286')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"link":[{"rel":"shortcut icon","type":"image\u002Fx-icon","href":"\u002Fwebsite-frontend\u002Ffavicon.ico?v=2"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fwebsite-frontend\u002Fapple-touch-icon.png?v=2"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Fwebsite-frontend\u002Ffavicon-32x32.png?v=2"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Fwebsite-frontend\u002Ffavicon-16x16.png?v=2"},{"rel":"manifest","href":"\u002Fwebsite-frontend\u002Fsite.webmanifest?v=2"},{"rel":"mask-icon","href":"\u002Fwebsite-frontend\u002Fsafari-pinned-tab.svg?v=2","color":"#1a1a1a"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-WPSZ286&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_6e56adae === 'function') {
    await nuxt_plugin_plugin_6e56adae(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_93bdb2ce === 'function') {
    await nuxt_plugin_dayjsplugin_93bdb2ce(app.context, inject)
  }

  if (typeof nuxt_plugin_intersectionobserver_38c28554 === 'function') {
    await nuxt_plugin_intersectionobserver_38c28554(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_7e86d59a === 'function') {
    await nuxt_plugin_gtm_7e86d59a(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugin9caf8fc8_01edc2fc === 'function') {
    await nuxt_plugin_templatesplugin9caf8fc8_01edc2fc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_previewclient_fe53587e === 'function') {
    await nuxt_plugin_previewclient_fe53587e(app.context, inject)
  }

  if (typeof nuxt_plugin_storyblokNuxtHelper_4e64c830 === 'function') {
    await nuxt_plugin_storyblokNuxtHelper_4e64c830(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookieconsentclient_4a1cd458 === 'function') {
    await nuxt_plugin_cookieconsentclient_4a1cd458(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_1d3e970e === 'function') {
    await nuxt_plugin_directives_1d3e970e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecookiesclient_32f3d87e === 'function') {
    await nuxt_plugin_vuecookiesclient_32f3d87e(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_57ec6061 === 'function') {
    await nuxt_plugin_filters_57ec6061(app.context, inject)
  }

  if (typeof nuxt_plugin_analytics_284b3bb6 === 'function') {
    await nuxt_plugin_analytics_284b3bb6(app.context, inject)
  }

  if (typeof nuxt_plugin_store_9429320a === 'function') {
    await nuxt_plugin_store_9429320a(app.context, inject)
  }

  if (typeof nuxt_plugin_breakpoints_db986c4c === 'function') {
    await nuxt_plugin_breakpoints_db986c4c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datadogclient_5e1fee6a === 'function') {
    await nuxt_plugin_datadogclient_5e1fee6a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_authenticationclient_231561db === 'function') {
    await nuxt_plugin_authenticationclient_231561db(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
